import {
  Box,
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';

interface WaitlistEntry {
  Id: number;
  ClassId: number;
  ClassDate: string;
  StartTime: string;
  StartDateTime: string;
  ClassSchedule?: {
    StartTime: string;
    ClassDescription?: {
      Name?: string;
    };
    Staff?: {
      Id: number;
    };
    Location?: {
      Id: number;
    };
  };
}

interface CancelWaitlistModalProps {
  children: React.ReactElement;
  entry: WaitlistEntry;
  onCancelSuccess?: () => void;
}

const buttonBorderRadius = `${mondayMindbody?.customization?.buttonBorderRadius}px`;

export function CancelWaitlistModal({ children, onCancelSuccess }: CancelWaitlistModalProps) {
  const toast = useToast();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);

  const close = () => {
    setIsLoading(false);
    onClose();
  };

  async function onConfirm(ev: React.FormEvent<HTMLElement>) {
    ev.preventDefault();
    setIsLoading(true);

    try {
      if (onCancelSuccess) {
        await onCancelSuccess();
      }
      close();
    } catch (error) {
      toast({
        title: "Une erreur est survenue, l'annulation n'a pas été effectuée",
        status: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Box>
      {React.cloneElement(children, { onClick: onOpen })}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent as="form">
          <ModalHeader>Quitter la liste d'attente</ModalHeader>
          <ModalBody>
            <Stack gap={3}>
              <Box>Voulez-vous vraiment quitter la liste d'attente ?</Box>
            </Stack>
          </ModalBody>
          <ModalFooter pt={0}>
            <ButtonGroup>
              <Button onClick={close} colorScheme="gray" variant="ghost" textTransform={'uppercase'}>
                Pas maintenant
              </Button>
              <Button
                textTransform={'uppercase'}
                isLoading={isLoading}
                colorScheme="red"
                variant="outline"
                onClick={onConfirm}
                borderRadius={buttonBorderRadius}
              >
                Quitter la liste d'attente
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
